import { PlaySolid } from "iconoir-react";
import React, { useContext, useEffect, useState } from "react";
import { SearchContext } from "../contexts/SearchContext";
import { WordNotFound } from "./NotFound";
import { Welcome } from "./Welcome";

export function WordDefinition() {
  const { word, response, isLoading } = useContext(SearchContext);

  const phoneticText = response?.phonetics?.find((phonetic) => phonetic.text)?.text;
  const [phoneticAudio, setPhoneticAudio] = useState(response?.phonetics?.find((phonetic) => phonetic.audio)?.audio);

  const audioRef = React.createRef<HTMLAudioElement>();

  const playAudio = () => {
    audioRef.current?.play();
  }

  useEffect(() => {
    setPhoneticAudio(response?.phonetics?.find((phonetic) => phonetic.audio)?.audio);
  }, [response])

  return <>
    {response?.word ? (
      <div className="mt-2 flex justify-between py-4">
      <div>
        <h1 className="text-4xl font-bold mb-1">{response.word}</h1>
        <p className="text-brand-purple tracking-widest">{phoneticText}</p>
      </div>

      {phoneticAudio && <button onClick={playAudio} className="p-4 my-2 bg-[#A445ED40] rounded-full active:ring active:ring-brand-purple focus:outline-none group">
        <PlaySolid className="text-brand-purple group-hover:scale-150 transition-all duration-200" />
        <audio ref={audioRef} src={phoneticAudio} />
      </button>}
    </div>
    ) : isLoading ? (
      <p className="my-24 w-full flex flex-col space-y-3 items-center text-lg font-bold">Loading...</p>
    ) : word ? (
      <WordNotFound />
    ) :  (
      <Welcome />
    )}
  </>
}